'use strict';

namespace core {

    class PriceInfo {

        total: number;
        tax: number;
        currency: string;

        constructor(private modalService:any){}

        onInfoClicked () {
            this.modalService.launch('partials/popups/tax', {
                tax: this.tax,
                currency: this.currency,
                total: this.total
            });
        };

    }

    angular
        .module('core')
        .directive('priceInfo', () => {
            return {
                restrict: 'E',
                template: '<div class="info-icon" ng-click="pi.onInfoClicked()"></div>',
                bindToController: {
                    total: '=',
                    tax: '=?',
                    currency: '@?'
                },
                scope: {},
                replace: true,
                controllerAs: 'pi',
                controller: PriceInfo
                };
        });

}
